"use strict";

export function installUIRuntimeBindings(_getUIRuntimeHolder) {
  // noop
}
//# sourceMappingURL=installUIRuntimeBindings.web.js.map